module.exports = __webpack_public_path__ + "static/img/page-bg.212c46f.png";


//////////////////
// WEBPACK FOOTER
// ./static/page-bg.png
// module id = 5YwF
// module chunks = 0